import { defineComponent as _defineComponent } from 'vue'
import ShopView from "@/components/layout/ShopView.vue";
	import AsiCard from "@/components/common/AsiCard.vue";
	import MaterialsChapters from "@/components/materials/MaterialsChapters.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Materials',
  setup(__props) {

	
return { __sfc: true,ShopView, AsiCard, MaterialsChapters }
}

})